export type NavLink = {
  label: string
  href: string
}

export type NavItem = NavLink & {
  children?: NavLink[]
}

export const business = {
  name: 'Pegasus Spas & Leisure Products',
  shortName: 'Pegasus Spas',
  url: 'https://www.pegasus-spas.com/',
  street: '171 South Main St',
  cityStateZip: 'Brooklyn, MI 49230',
  city: 'Brooklyn',
  state: 'MI',
  zip: '49230',
  phone: '517-592-3227',
  phoneHref: 'tel:+15175923227',
  smsHref: 'sms:+15175923227',
  hours: [
    { days: 'Monday–Friday', time: '10:00am–6:00pm' },
    { days: 'Saturday', time: '9:00am–3:00pm' },
  ],
  localBar:
    'Hot Tubs, Outdoor Furniture & Spa Service in Brooklyn, MI | Serving Jackson, Lenawee, Hillsdale & Washtenaw Counties Since 1977',
  footerSeo:
    'Pegasus Spas is a family-owned hot tub, outdoor furniture and spa service showroom in Brooklyn, Michigan, serving Jackson, Lenawee, Hillsdale and Washtenaw counties since 1977.',
}

export const routes = {
  home: '/',
  hotTubs: '/hot-tubs',
  sundance: '/hot-tubs/sundance-spas',
  viking: '/hot-tubs/viking-spas',
  availableSpas: '/specials#available-spas',
  preOwned: '/hot-tubs/certified-pre-owned',
  financing: '/financing',
  furniture: '/backyard-living',
  grills: '/backyard-living/big-green-egg',
  fireTables: '/backyard-living/fire-tables',
  umbrellas: '/backyard-living/umbrellas',
  service: '/service',
  spaCare: '/service/spa-care',
  serviceGuarantee: '/service/work-guarantee',
  supplies: '/shop',
  filters: '/shop/filters',
  maintenance: '/shop/maintenance',
  spaChemicals: '/shop/spa-chemicals',
  poolChemicals: '/shop/pool-chemicals',
  bigGreenEggAccessories: '/shop/big-green-egg-accessories',
  covers: '/covers',
  coverLifts: '/covers/cover-lifts',
  about: '/about',
  reviews: '/about/google-reviews',
  location: '/location',
  referrals: '/referrals',
  specials: '/specials',
  contact: '/contact',
  coldPlunge: '/cold-plunge-tubs',
  health: '/health-benefits',
}

/** Every non-home destination in the site, rendered as a placeholder page for now. */
export const placeholderPages: { path: string; title: string }[] = [
  { path: routes.hotTubs, title: 'Hot Tubs' },
  { path: routes.sundance, title: 'Sundance Spas' },
  { path: routes.viking, title: 'Viking Spas' },
  { path: routes.preOwned, title: 'Certified Pre-Owned Spas' },
  { path: routes.financing, title: 'Financing' },
  { path: routes.furniture, title: 'Backyard Living' },
  { path: routes.grills, title: 'Big Green Egg' },
  { path: routes.fireTables, title: 'Fire Tables' },
  { path: routes.umbrellas, title: 'Umbrellas' },
  { path: routes.coldPlunge, title: 'Cold Plunge Tubs' },
  { path: routes.service, title: 'Spa Service & Repair' },
  { path: routes.spaCare, title: 'Spa Care & FAQs' },
  { path: routes.serviceGuarantee, title: 'Service Work Guarantee' },
  { path: routes.covers, title: 'Premium Replacement Covers' },
  { path: routes.coverLifts, title: 'Cover Lifts' },
  { path: routes.supplies, title: 'Spa & Pool Supplies' },
  { path: routes.filters, title: 'Filters' },
  { path: routes.maintenance, title: 'Maintenance' },
  { path: routes.spaChemicals, title: 'Spa Chemicals' },
  { path: routes.poolChemicals, title: 'Pool Chemicals' },
  { path: routes.bigGreenEggAccessories, title: 'Big Green Egg Accessories' },
  { path: routes.about, title: 'Why Pegasus' },
  { path: routes.reviews, title: 'Google Reviews' },
  { path: routes.health, title: 'Health Benefits' },
  { path: routes.referrals, title: 'Referrals' },
  { path: routes.specials, title: 'Current Specials' },
  { path: routes.location, title: 'Location & Hours' },
  { path: routes.contact, title: 'Contact Pegasus' },
]

export const navigation: NavItem[] = [
  {
    label: 'Hot Tubs',
    href: routes.hotTubs,
    children: [
      { label: 'Explore Hot Tubs', href: routes.hotTubs },
      { label: 'Sundance Spas', href: routes.sundance },
      { label: 'Viking Spas', href: routes.viking },
      { label: 'Available Spas', href: routes.availableSpas },
      { label: 'Certified Pre-Owned Spas', href: routes.preOwned },
      { label: 'Financing', href: routes.financing },
    ],
  },
  {
    label: 'Backyard Living',
    href: routes.furniture,
    children: [
      { label: 'Outdoor Furniture', href: routes.furniture },
      { label: 'Big Green Egg', href: routes.grills },
      { label: 'Fire Tables', href: routes.fireTables },
      { label: 'Umbrellas', href: routes.umbrellas },
    ],
  },
  {
    label: 'Service',
    href: routes.service,
    children: [
      { label: 'Service & Repair', href: routes.service },
      { label: 'Spa Care & FAQs', href: routes.spaCare },
      { label: 'Service Work Guarantee', href: routes.serviceGuarantee },
      { label: 'Supplies & Chemicals', href: routes.supplies },
    ],
  },
  {
    label: 'Covers',
    href: routes.covers,
    children: [
      { label: 'Premium Replacement Covers', href: routes.covers },
      { label: 'Cover Lifts', href: routes.coverLifts },
    ],
  },
  {
    label: 'Shop',
    href: routes.supplies,
    children: [
      { label: 'Spa & Pool Supplies', href: routes.supplies },
      { label: 'Filters', href: routes.filters },
      { label: 'Maintenance', href: routes.maintenance },
      { label: 'Spa Chemicals', href: routes.spaChemicals },
      { label: 'Pool Chemicals', href: routes.poolChemicals },
      { label: 'Big Green Egg Accessories', href: routes.bigGreenEggAccessories },
    ],
  },
  {
    label: 'About',
    href: routes.about,
    children: [
      { label: 'Why Pegasus', href: routes.about },
      { label: 'Our Story', href: routes.about },
      { label: 'Google Reviews', href: routes.reviews },
      { label: 'Contact, Location & Hours', href: routes.location },
      { label: 'Referrals', href: routes.referrals },
    ],
  },
]

export const images = {
  logo: 'https://cdn.magicpatterns.com/uploads/emcb92Q1bKmEtQ6yTzYfmP/pegasus-logo-current.jpg',
  hero: 'https://cdn.magicpatterns.com/uploads/5M9Mb8ZpiTDf27nVrXj8p5/hero2.png',
  pathHotTubs: 'https://cdn.magicpatterns.com/patterns/generated-images/3e3c9eca-c3e1-4756-8bfc-0fd41cc6c7b0.jpg',
  pathBackyard: 'https://cdn.magicpatterns.com/patterns/generated-images/1de29625-0848-4d1e-8240-df90bf1bd6ac.jpg',
  pathColdPlunge: 'https://cdn.magicpatterns.com/patterns/generated-images/7c72c519-f8c9-4b25-8509-f3e7b1dd0054.jpg',
  pathService: 'https://cdn.magicpatterns.com/patterns/generated-images/8ac043c0-8e2f-4d44-aa9a-32c5a36aacd0.jpg',
  pathCovers: 'https://cdn.magicpatterns.com/patterns/generated-images/09e3da05-f3a4-41c1-bdc6-fc6a627924f4.jpg',
  whyPegasus: 'https://cdn.magicpatterns.com/patterns/generated-images/95644ce6-bc27-4dc3-be8d-44f15042740c.jpg',
  sundance: 'https://cdn.magicpatterns.com/patterns/generated-images/6a13c95e-6e42-40d7-8ffb-dc9e0cb1a0d0.jpg',
  viking: 'https://cdn.magicpatterns.com/patterns/generated-images/176bc401-a6ae-4f1d-9091-73247bf5c40a.jpg',
  backyardLiving: 'https://cdn.magicpatterns.com/patterns/generated-images/0f1241ab-2722-416c-8850-bae10d192c7f.jpg',
  service: 'https://cdn.magicpatterns.com/patterns/generated-images/5e2ba009-cda1-4b06-968a-b14e0573f794.jpg',
  showroom: 'https://cdn.magicpatterns.com/patterns/generated-images/98abbb57-b778-4c82-8a40-55231d8a26ff.jpg',
}

export const trustPoints = [
  'Serving local families since 1977',
  'A real showroom in Brooklyn, MI',
  'Service and support after the sale',
  'Michigan-ready products',
]

export type Pathway = {
  title: string
  description: string
  href: string
  image: string
  alt: string
}

export const pathways: Pathway[] = [
  {
    title: 'Hot Tubs',
    description: 'Explore Sundance, Viking, available and certified pre-owned spas.',
    href: routes.hotTubs,
    image: images.pathHotTubs,
    alt: 'Hot tub with clear water and jets running on a residential wood deck surrounded by trees',
  },
  {
    title: 'Backyard Living',
    description: 'Outdoor furniture, Big Green Egg, fire tables, umbrellas and more.',
    href: routes.furniture,
    image: images.pathBackyard,
    alt: 'Poly outdoor chairs and a dining set on a lawn near an inland Michigan lake',
  },
  {
    title: 'Cold Plunge Tubs',
    description: 'Explore cold-plunge options for home.',
    href: routes.coldPlunge,
    image: images.pathColdPlunge,
    alt: 'Compact cold plunge tub on a backyard patio with a folded towel on its edge',
  },
  {
    title: 'Spa Service & Care',
    description: 'Get help with service, repairs, water care and common questions.',
    href: routes.service,
    image: images.pathService,
    alt: 'Technician working inside an open hot tub equipment bay with plumbing and a replacement filter',
  },
  {
    title: 'Replacement Covers',
    description: 'Use the recently redesigned guided process to order the right spa cover.',
    href: routes.covers,
    image: images.pathCovers,
    alt: 'Thick vinyl spa cover partly folded open on a hot tub with a cover lift arm attached',
  },
]

export const utilityLinks: NavLink[] = [
  { label: 'Shop Spa & Pool Supplies', href: routes.supplies },
  { label: 'View Current Specials', href: routes.specials },
  { label: 'Financing Options', href: routes.financing },
]

export const whyPoints = [
  'Family-owned and locally established',
  'Long-standing manufacturer relationships',
  'Showroom guidance before you buy',
  'Spa care and service support afterward',
]

export const brandRoutes = [
  {
    name: 'Sundance Spas',
    description: 'Explore official Sundance product information and model choices.',
    href: routes.sundance,
    image: images.sundance,
    alt: 'Six-seat hot tub with lit clear water on a paver patio beside a Midwestern home at dusk',
  },
  {
    name: 'Viking Spas',
    description: 'Explore Viking spa models and options available through Pegasus.',
    href: routes.viking,
    image: images.viking,
    alt: 'Hot tub with a wood-look cabinet on a paver pad in a modest fenced backyard with maple trees',
  },
]

export const hotTubLinks: NavLink[] = [
  { label: 'See Available Spas', href: routes.availableSpas },
  { label: 'Certified Pre-Owned Spas', href: routes.preOwned },
  { label: 'Financing Options', href: routes.financing },
]

export const backyardLinks: NavLink[] = [
  { label: 'Explore Outdoor Furniture', href: routes.furniture },
  { label: 'Big Green Egg', href: routes.grills },
  { label: 'Fire Tables', href: routes.fireTables },
  { label: 'Umbrellas', href: routes.umbrellas },
]

export const serviceLinks: NavLink[] = [
  { label: 'Get Spa Service Help', href: routes.service },
  { label: 'Explore Spa Care', href: routes.spaCare },
  { label: 'Service Work Guarantee', href: routes.serviceGuarantee },
  { label: 'Shop Supplies & Filters', href: routes.supplies },
]

export const specialsCopy = {
  eyebrow: 'Current Specials',
  heading: "See What's Happening at Pegasus Right Now",
  body:
    'Offers and in-stock opportunities change throughout the year. Check the current specials page for the latest hot tub, outdoor living and store promotions.',
}

export const footerGroups: { title: string; links: NavLink[] }[] = [
  {
    title: 'Hot Tubs',
    links: [
      { label: 'Explore Hot Tubs', href: routes.hotTubs },
      { label: 'Sundance Spas', href: routes.sundance },
      { label: 'Viking Spas', href: routes.viking },
      { label: 'Available Spas', href: routes.availableSpas },
      { label: 'Certified Pre-Owned Spas', href: routes.preOwned },
      { label: 'Financing', href: routes.financing },
    ],
  },
  {
    title: 'Backyard Living',
    links: [
      { label: 'Outdoor Furniture', href: routes.furniture },
      { label: 'Big Green Egg', href: routes.grills },
      { label: 'Fire Tables', href: routes.fireTables },
      { label: 'Umbrellas', href: routes.umbrellas },
      { label: 'Cold Plunge Tubs', href: routes.coldPlunge },
    ],
  },
  {
    title: 'Service & Spa Care',
    links: [
      { label: 'Service & Repair', href: routes.service },
      { label: 'Spa Care & FAQs', href: routes.spaCare },
      { label: 'Service Work Guarantee', href: routes.serviceGuarantee },
      { label: 'Premium Replacement Covers', href: routes.covers },
      { label: 'Cover Lifts', href: routes.coverLifts },
    ],
  },
  {
    title: 'Shop',
    links: [
      { label: 'Spa & Pool Supplies', href: routes.supplies },
      { label: 'Filters', href: routes.filters },
      { label: 'Maintenance', href: routes.maintenance },
      { label: 'Spa Chemicals', href: routes.spaChemicals },
      { label: 'Pool Chemicals', href: routes.poolChemicals },
      { label: 'Big Green Egg Accessories', href: routes.bigGreenEggAccessories },
    ],
  },
  {
    title: 'About',
    links: [
      { label: 'Why Pegasus', href: routes.about },
      { label: 'Our Story', href: routes.about },
      { label: 'Google Reviews', href: routes.reviews },
      { label: 'Health Benefits', href: routes.health },
      { label: 'Referrals', href: routes.referrals },
    ],
  },
  {
    title: 'Visit & Connect',
    links: [
      { label: 'Current Specials', href: routes.specials },
      { label: 'Location & Hours', href: routes.location },
      { label: 'Contact', href: routes.contact },
    ],
  },
]
